declare global {
  // eslint-disable-next-line no-unused-vars
  interface String {
    replaceAll(__searchValue: string | RegExp, __replaceValue: string): string;
  }
}
if (typeof String.prototype.replaceAll === 'undefined') {
  String.prototype.replaceAll = function (match, replace) {
    return this.replace(new RegExp(match, 'g'), () => replace as string);
  };
}

export {};
